import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { NODE_URL} from "./Config";
import Cookies from 'js-cookie';




export const membership = createAsyncThunk(
    "post/membership",
    async (data) => { 
        let url = NODE_URL+'membership';
        const token=Cookies.get("token");
        try{
            
            const response = (await axios.post(url,data,{
                
                    headers: {
                        Authorization: `Bearer ${token}`, 
                    },
            }

            )).data
          
            if(response.status == "success"){
                return Promise.resolve(response)
            } else {
                return Promise.reject(response)
            }
        }catch (error) {
            return Promise.reject(error)
        }
    }
)


export const MembershipUpgrade = createAsyncThunk(
    "post/MembershipUpgrade",
    async (data) => { 
        let url = NODE_URL+'MembershipUpgrade';
        // const token=Cookies.get("token");
        try{
            
            const response = (await axios.post(url,data)).data
            if(response.status == "success"){
                return Promise.resolve(response)
            } else {
                return Promise.reject(response)
            }
        }catch (error) {
            return Promise.reject(error)
        }
    }
)






